import axiosInstance from '../axiosInstance.js'

export default {
  /**
   * onboarding artist
   *
   */
  registerArtist(onboardingPayload) {
    return axiosInstance.post(
      '/register',
      JSON.stringify({
        email: onboardingPayload.email,
        firstName: onboardingPayload.firstName,
        lastName: onboardingPayload.lastName,
        password: onboardingPayload.password,
        language: onboardingPayload.language,
        subscribed: onboardingPayload.subscribed
      })
    )
  },

  /**
   * onboarding artist
   *
   */
  async onboardingArtist(onboardingPayload) {
    return axiosInstance.post(
      '/quick-onboard',
      JSON.stringify({
        employee: {
          email: onboardingPayload.email,
          firstName: onboardingPayload.firstName,
          lastName: onboardingPayload.lastName,
          password: onboardingPayload.password,
          subscribed: onboardingPayload.subscribed,
          language: onboardingPayload.language
        },
        stage: {
          title: onboardingPayload.initial_stage_name,
          fqdn: onboardingPayload.initial_stage_slug,
          country: onboardingPayload.initial_stage_country,
          language: onboardingPayload.language
        }
      })
    )
  },

  /**
   * Confirm artist email
   *
   */
  confirmArtistEmail(emailConfirmationToken) {
    return axiosInstance.get(`/confirmations/${emailConfirmationToken}`)
  }
}
